import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {KeycloakService} from 'keycloak-angular';
import {switchMap} from 'rxjs/operators';

import {clientRoles} from '../../../../core/constants/client-roles.config';
import {clients} from '../../../../core/constants/clients.config';
import {Article} from '../../../../core/models/articles/articles.model';
import {User} from '../../../../core/models/users/users.model';
import {ArticlesService} from '../../../../core/services/articles/articles.service';
import {ToastService} from '../../../../core/services/toast/toast.service';
import {UsersService} from '../../../../core/services/users/users.service';
import {ArticleFavoriteService} from '../../article-favorite.service';

@Component({
  selector: 'app-article-detail',
  templateUrl: './article-detail.component.html',
  styleUrls: ['./article-detail.component.css'],
  standalone: false,
})
export class ArticleDetailComponent implements OnInit {
  public clientRoles = clientRoles;
  public userRoles!: string[];

  // data
  public article?: Article;
  public user?: User & { favArticles?: string[] };

  constructor(
    private articlesService: ArticlesService,
    private usersService: UsersService,
    private keycloakService: KeycloakService,
    private route: ActivatedRoute,
    private router: Router,
    private toastService: ToastService,
    private articleFavoriteService: ArticleFavoriteService,
  ) {
  }

  async ngOnInit() {
    this.userRoles = this.keycloakService.getUserRoles(false, clients.API);
    this.usersService.getCurrentUser([]).subscribe((user) => {
      this.user = user as typeof this.user;
    });
    this.route.params.pipe(
      switchMap(({ id }) => this.articlesService.getOne(id)),
    ).subscribe({
      next: (article: Article) => {
        this.article = article;
      },
      error: (error) => {
        if (error.status === 403) {
          this.toastService.warning(
            $localize`:@@article-not-authorized-title:Nicht autorisiert`,
            $localize`:@@article-not-authorized-message:Sie haben keine Berechtigung, diesen Artikel zu betrachten.`,
          );
        } else if (error.status === 404) {
          this.toastService.warning(
            $localize`:@@article-not-found:Nicht gefunden`,
            $localize`:@@article-not-found-message:Der Artikel konnte nicht gefunden werden.`,
          );
        } else {
          this.toastService.error(
            $localize`:@@article-error:Fehler`,
            $localize`:@@article-error-message:Beim Laden des Artikels ist ein Fehler aufgetreten.`,
            error,
          );
        }
        this.router.navigate(['/home']);
      }
    });
  }

  addArticleToFavorites() {
    if (!this.user || !this.article) {
      return;
    }

    this.articleFavoriteService.addFavorite(this.user, this.article);
  }

  removeArticleFromFavorites() {
    if (!this.user || !this.article) {
      return;
    }

    this.articleFavoriteService.removeFavorite(this.user, this.article);
  }
}
